var playList = null;
var playListStartIndex = 0;
var playListCurrentIndex = 0;
$(document).ready(function()
{
	if(pageMode == "default")
	{
		renderLatestPrograms();
	}
	else
	{
		renderPlaylistItems();
	}
	window.getPlayListItems(function(data)
	{
		setPlaylist(data);
	});
});

function renderLatestPrograms()
{
	window.getLatestPrograms(function(data)
	{
		var itemListTmpl = Handlebars.compile($("#itemListTemplate").html());
		var sectionData = {};
		sectionData.sectionTitle = NEU.util.getLocalizedString("latest_text");
		sectionData.itemDataType = "program";
		sectionData.itemList = window.processSectionItems(data, "program");
		sectionData.hasItemsData = sectionData.itemList.length > 0 ? true : false;
		var html = itemListTmpl(sectionData);
		$("#LatestPrograms").html(html);
		initSectionItemFunctions();
	});
}

function renderPlaylistItems()
{
	window.getPlayListItems(function(data)
	{
		var itemListTmpl = Handlebars.compile($("#itemListTemplate").html());
		var sectionData = {};
		sectionData.sectionTitle = NEU.util.getLocalizedString("watchlist");
		sectionData.itemDataType = "program";
		if(pageMode == "playlist")
		{
			sectionData.itemList = window.processSectionItems(data, "program", true);
		}
		else
		{
			sectionData.itemList = window.processSectionItems(data, "program");
		}
		sectionData.hasItemsData = sectionData.itemList.length > 0 ? true : false;
		var html = itemListTmpl(sectionData);
		$("#watchlistItems").html(html);
		initSectionItemFunctions();
		if($("#watchlistItems").length > 0)
		{
			$("#watchlistItems").find('.program-section-' + video.id).addClass("watching");
		}
	});
}

function setPlaylist(data)
{
	playList = data;
	for (var i = 0; i < playList.length; i++)
	{
		if (playList[i].id == window.video.id)
		{
			playListStartIndex = i;
			playListCurrentIndex = playListStartIndex;
			break;
		}
	}
	console.log("playList set");
}

function listenVideoComplete(id)
{
	if ((playListCurrentIndex != playListStartIndex - 1) && !(playListStartIndex == 0 && playListCurrentIndex == playList.length - 1 && pageMode == "playlist"))
	{
		if(pageMode == "playlist")
		{
			playListCurrentIndex++;
		}
		// if(playListCurrentIndex > playList.length - 1)
		// {
		// 	playListCurrentIndex = 0;
		// }
		// Call video detail to update current Program
		var feedUrl = config.LOC_SERVER + "video/" + playList[playListCurrentIndex].seoName + "?format=json&callback=?";
		$.getJSON(feedUrl, function (data)
		{
			if(data.liveState == 0 || data.noAccess || data.blackout != undefined)
			{
				location.href = config.LOC_SERVER + "video/" + playList[playListCurrentIndex].seoName + "?playlist=true";
			}
			else
			{
				var newNltrackPath = "/video/" + data.seoName;
				NLTracker.trackPage(newNltrackPath);
				nlPlay(postProcessVideo(playList[playListCurrentIndex]));
				currentProgramChange(playList[playListCurrentIndex]);
			}
		});
	}
}

function currentProgramChange(newProgram)
{
	var url = config.LOC_SERVER + "video/" + newProgram.seoName;
	var title = getLocalizedString("video_page_title").replace(/\&gt\;/, ">").replace(/\{0\}/, newProgram.name);
	if ($("#watchlistItems .program-section").length > 0)
	{
		$("#watchlistItems .program-section").removeClass("watching");
		$("#watchlistItems").find('.program-section-' + newProgram.id).addClass("watching");
	}
	if (pageMode == "playlist")
	{
		url += "?playlist=true";
	}
	document.title = title;
	if ('pushState' in history)
	{
		history.pushState(null, title, url)
	}
	var $programDetail = $("#playerDetailInfo");
	$programDetail.find(".name").html(newProgram.name);
	if(newProgram.runtimeHours)
	{
		$programDetail.find(".duration").html(newProgram.runtimeHours);
	}
}

function postProcessVideo(video)
{
	if (video.liveState == 1)
	{
		video.isLive = true;
	}
	if (video.liveState == 2)
	{
		video.isLive = true;
		video.isDVRLive = true;
	}
	return video;
}